export default __webpack_public_path__ + "static/media/ritail_new_welcome.a3eb57df.svg";